// extracted by mini-css-extract-plugin
module.exports = {"label":"StDWO___Label-module__label","horizontalStyle":"_1v3M2___Label-module__horizontalStyle","required":"_2FBjb___Label-module__required"};